module.exports = __webpack_public_path__ + "img/action-collect.1fa1422a.svg";